import React from 'react';
import { strToFormattedDate } from "../../../helpers/formatHelper";

export default function DatetimeInput({
    id,
    label,
    placeholder,
    required = false,
    value,
    onChange,
    disabled = false,
    helper = '',
    error = '',
}) {
    const formattedValue = strToFormattedDate(value, "yyyy-MM-dd HH:mm");
    return (
        <div className="w-full">
            <label htmlFor={id} className={`block mb-2 font-medium text-gray-900 ${error ? 'text-red-700' : ''}`}>{`${label} ${required ? "*" : ""}`}</label>
            <input
              type="datetime-local"
              id={id}
              className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 ${disabled ? 'cursor-not-allowed' : ''} ${error ? 'border-red-500 text-red-900 placeholder-red-700' : ''}`}
              placeholder={placeholder}
              required={required}
              value={formattedValue}
              onChange={e => onChange(e.target.value)}
              disabled={disabled}
            />
            <p id={`helper-${id}`} className="mt-2 text-sm text-gray-600">{helper}</p>
            <p id={`error-${id}`} className="mt-2 text-sm text-red-600">{error}</p>
            { required && value === "" && <p id={`required-${id}`} className="mt-2 text-sm text-red-600">Champ obligatoire.</p>}
        </div>
    );
};
